import { createSlice } from '@reduxjs/toolkit';
import { getParamFromUrl } from '../../utilities/urlResolver';

const initialState = {
  what: false,
  where: false,
  when: false,
  budget: false,
  who: !!(getParamFromUrl('openFilter') === 'who'),
};

export const mainFilterModalsSlice = createSlice({
  name: 'mainFilter',
  initialState,
  reducers: {
    updateMainFilterModal: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const { updateMainFilterModal } = mainFilterModalsSlice.actions;
export default mainFilterModalsSlice.reducer;
